import React from 'react';
import CSS from 'csstype'
import {
    StyledSpin as Spin
}  from './styles'

interface IProps {
    style?: CSS.Properties
    size?: 'small' | 'large' | 'default'
}

function Loader({ style, size = 'default' }: IProps ) {
    return (
        <Spin style={style} size={size} />
    );
}

export default Loader;
